import React, { FC, useState, useEffect } from 'react'
import { observer } from 'mobx-react'
import { RouteComponentProps } from 'react-router-dom'
import { IonPage, IonContent, IonFooter } from '@ionic/react'
import { MktAmountBoard, PayModal, CardEquityModal } from '@cps'
import { useHistoryNew, modalLayer, toast } from '@utils'
import mktController from 'controllers/mktController'
import { format, toPrice } from '@dt/fe-utils'
import { memberMobx, virtualOrderMobx } from '@mobxStore'
import { TermsTick, ChooseStore, BackHeader, CardShape, StoreListModal, CardBuyItem } from 'pages/mkt/components'
import i18n from 'i18next'
import './index.scss'

interface IProps extends IPage, RouteComponentProps { }

const RechargeTypeOff = 'discountFee'

const Recharge: FC<IProps> = ({ match }) => {
  const history = useHistoryNew()
  const { cardId } = match.params as any
  const { getMemberGiftCardDetail, brandConfig } = memberMobx
  // Component State
  const [cardInfo, setCardInfo] = useState<any>(null)
  const [showAmountModal, setShowAmountModal] = useState<boolean>(false)
  const [isAgree, setIsAgree] = useState<boolean>(false)
  const [showTip, setShowTip] = useState<boolean>(false)
  const [clause, setClause] = useState<IClauseInfo>(null)
  const [storeInfo, setStoreInfo] = useState<IStoreInfo>({ storeId: 0, storeName: '' })
  const [isShow, setIsShow] = useState<boolean>(true)
  // Component Event
  const changeCustom = (val: number) => {
    handleBuy({
      recharge: val,
      give: 0,
      storeId: storeInfo.storeId,
      reloadType: cardInfo?.giftcard?.reloadType
    })
  }
  const checkRule = () => {
    if (brandConfig.giftcardCzSetting && !brandConfig.giftcardCzSetting.channels.includes('mobile')) {
      toast({ message: i18n.t('mkt.member.notRechargeTip') })
      return false
    }
    if (!isAgree && clause?.clauseName) {
      setShowTip(true)
      return false
    }
    return true
  }
  const handleAdd = (item: any) => {
    if (cardInfo.giftcard.status === 'disable' || cardInfo.status === 'disable') {
      toast({ message: i18n.t('mkt.giftCard.gcDisableTip') })
      return
    }
    if (!checkRule()) return
    if (brandConfig?.isSelectStoreWhenCz && !storeInfo.storeId) {
      modalLayer(StoreListModal, { showIds: cardInfo.giftcard.isAllStore ? null : cardInfo.giftcard.storeIds }, 'StoreListModal').then((val: any) => {
        setStoreInfo({ storeId: val.storeId, storeName: val.storeName })
        handleBuy({
          recharge: item.recharge,
          give: item.give,
          cardRechargeId: item.id,
          storeId: val.storeId,
          reloadType: cardInfo.giftcard.reloadType
        })
      }).catch(() => { })
      return
    } else {
      handleBuy({
        recharge: item.recharge,
        give: item.give,
        cardRechargeId: item.id,
        storeId: brandConfig?.isSelectStoreWhenCz ? storeInfo.storeId : 0,
        reloadType: cardInfo.giftcard.reloadType
      })
    }
  }
  const handleScroll = (e: any) => {
    setTimeout(() => {
      if (e.detail.scrollTop >= 50) {
        setIsShow(false)
      } else {
        setIsShow(true)
      }
    }, 10)
  }
  const showCardEquity = (type: 'store' | 'gcDetail') => {
    modalLayer(CardEquityModal, { cardInfo, type, cardType: 'giftcard' }).then(() => { }, () => { })
  }
  const changeTermsStatus = (status: boolean) => {
    if (status) setShowTip(false)
    setIsAgree(status)
  }
  let posting = false
  const handleBuy = async (obj: any) => {
    if (posting) return
    posting = true
    const orderParams = virtualOrderMobx.getGcRechargeOrder({
      cardNo: cardInfo.cardNo,
      giftcardId: cardInfo.giftcardId,
      giftcardName: cardInfo.giftcard.giftcardName
    }, obj)
    modalLayer(PayModal, { scene: 'giftcard_buy', orderPara: orderParams, history })
    posting = false
    // const result: any = await virtualOrderMobx.placeGcRechargeOrder({
    //   cardNo: cardInfo.cardNo,
    //   giftcardId: cardInfo.giftcardId,
    //   giftcardName: cardInfo.giftcard.giftcardName
    // }, obj)
    // if (result && result.ordersId) {
    //   const prepayCreate = await virtualOrderMobx.startPay(result.ordersId)
    //   if (prepayCreate && prepayCreate.prepayCreateId) {
    //     history.replace({
    //       pathname: `/pay/${result.ordersId}`,
    //       search: `scene=giftcard_buy&pcid=${prepayCreate.prepayCreateId}`
    //     })
    //   }
    // }
  }
  // Component Effect
  useEffect(() => {
    getMemberGiftCardDetail({
      memberCardId: cardId,
    }).then((res: any) => {
      if (res) {
        setCardInfo(res)
      }
    })
  }, [cardId])
  useEffect(() => {
    if (memberMobx.brandConfig?.clauses?.giftcard?.status === 'enable') {
      setClause(memberMobx.brandConfig.clauses.giftcard)
      setIsAgree(memberMobx.brandConfig.clauses.giftcard.isDefaultCheck)
    }
  }, [memberMobx.brandConfig])
  return (
    <IonPage
      className='giftcard-recharge-page'
    >
      <BackHeader isShow={isShow} title={`${i18n.t('mkt.giftCard.giftCardRecharge')} ${brandConfig?.isSelectStoreWhenCz ? '' : i18n.t('mkt.giftCard.onlineRecharge')}`}></BackHeader>
      <IonContent className='page-content' scrollEvents onIonScroll={handleScroll}>
        {
          cardInfo &&
            <div className='recharge-block'>
              <div className='card-title'>{cardInfo.giftcard.giftcardName}</div>
              <div className='card-face-block' style={!cardInfo?.extra?.shape || cardInfo?.extra?.shape === 'rectangle' ? { height: '63vw' } : {}}>
                <CardShape shape={cardInfo?.extra?.shape || 'rectangle'} cardFace={mktController.getGiftCardCover(cardInfo)} border='shadow' isScale={false}></CardShape>
              </div>
              <div className='recharge-list'>
                {
                  cardInfo.giftcard?.reloadAmounts.map((item: any, index: number) => (
                    <div className='recharge-info-block' key={index} onClick={() => handleAdd(item)}>
                      <CardBuyItem color='grey' isRecommend={!!item?.ifRecommend}>
                        <div className='recharge-info-price'>{toPrice(item.recharge)}</div>
                        {item.give > 0 && (
                          <div className={`recharge-info-des ${cardInfo.giftcard?.reloadType === RechargeTypeOff ? 'origin-price' : ''}`}>
                            {cardInfo.giftcard?.reloadType === RechargeTypeOff
                              ? `${i18n.t('mkt.giftCard.originPrice')} ${toPrice(item.recharge + item.give)}`
                              : `${i18n.t('mkt.giftCard.giveAway')} ${toPrice(item.give)}`}
                          </div>
                        )}
                      </CardBuyItem>
                    </div>
                  ))
                }
                {
                  !!cardInfo.giftcard.allowCustomizeLoad &&
                    <div
                      className='recharge-info-block'
                      onClick={() => {
                        if (cardInfo.giftcard.status === 'disable' || cardInfo.status === 'disable') {
                          toast({ message: i18n.t('mkt.giftCard.gcDisableTip') })
                          return
                        }
                        if (!checkRule()) return
                        if (brandConfig?.isSelectStoreWhenCz && !storeInfo.storeId) {
                          modalLayer(StoreListModal, { showIds: cardInfo.giftcard.isAllStore ? null : cardInfo.giftcard.storeIds }, 'StoreListModal').then((val: any) => {
                            setStoreInfo({ storeId: val.storeId, storeName: val.storeName })
                            setShowAmountModal(true)
                          }).catch(() => { })
                        } else {
                          setShowAmountModal(true)
                        }
                      }}
                    >
                      <CardBuyItem color='grey'>
                        <div className='recharge-custom-price'>{i18n.t('newCart.auto')}</div>
                        <div className='recharge-custom-des'>{`${i18n.t('mkt.giftCard.maxLoad', { amount: format.toPriceNoCurrency(cardInfo.giftcard.maxLoad, -1) })}, ${i18n.t('mkt.giftCard.minLoad', { amount: format.toPriceNoCurrency(cardInfo.giftcard.minLoad, -1) })}`}</div>
                      </CardBuyItem>
                    </div>
                }
              </div>
              <div className='card-detail-enter-block'>
                <div className='enter-item' onClick={() => showCardEquity('gcDetail')}>
                  <span>{i18n.t('mkt.member.useRule')}</span>
                  <i className='iconfont icon-chevron-right'></i>
                </div>
                <div className='enter-item' onClick={() => showCardEquity('store')}>
                  <span>{i18n.t('mkt.member.applyStore')}</span>
                  <i className='iconfont icon-chevron-right'></i>
                </div>
              </div>
            </div>
        }
      </IonContent>
      <IonFooter className='page-footer'>
        {
          clause?.clauseName && <div className='amount-title'><TermsTick terms={clause} isCheck={isAgree} showTip={showTip} onChange={(check: boolean) => changeTermsStatus(check)} /></div>
        }
        {
          cardInfo &&
            <div className='card-choose'>
              <ChooseStore scene='giftCard' openChoose={!!brandConfig?.isSelectStoreWhenCz} detailInfo={cardInfo.giftcard} storeInfo={storeInfo} onChange={(info: any) => setStoreInfo(info)}></ChooseStore>
            </div>
            // <div className='card-choose'>
            //   <div onClick={() => history.push(`/iGc/giftCard/${cardInfo.cardNo}`)}>{i18n.t('mkt.giftCard.giftcardDetails')}</div>
            //   {
            //   brandConfig?.isSelectStoreWhenCz &&
            //     <>
            //       <div className='card-choose-line'>｜</div>
            //       <ChooseStore scene='giftCard' openChoose={!!brandConfig?.isSelectStoreWhenCz} detailInfo={cardInfo.giftcard} storeInfo={storeInfo} onChange={(info: any) => setStoreInfo(info)}></ChooseStore>
            //     </>
            //   }
            // </div>
        }
      </IonFooter>
      {/* 自定义金额 */}
      <MktAmountBoard
        visible={showAmountModal}
        min={cardInfo && cardInfo.giftcard.minLoad}
        max={cardInfo && cardInfo.giftcard.maxLoad}
        onClose={() => setShowAmountModal(false)}
        onSave={(val: number) => changeCustom(val)}
      >
      </MktAmountBoard>
    </IonPage>
  )
}

export default observer(Recharge)
